import React, { useCallback, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { PageSection } from 'adc-ui-components';
import { Formik, Form } from 'formik';

import { connect } from 'react-redux';

import AccountInfoPushdown from '../../AccountInfoPushdown';
import RedirectToHelpAndSupport from '../../Errors/RedirectToHelpAndSupport';
import FixedActions from '../../../components/orders/FixedActions';
import { selectDevices } from '../../../actions/order';
import { getAccount } from '../../../actions/account';

import { flagEnabled } from '../../../helpers/featureFlags';
import { transformServices } from '../../../helpers/services';

import Services from './Services';
import { RETURNS_DOWNTIME, RETURNS_SELECT_REASON } from '../../../helpers/routes';
import { getReturnableDevices } from '../../../actions/devices';
import { loadReturns } from '../../../actions/returns';
import { returnsDisabled } from '../../../helpers/returns';
import LoadingWrapper from '../../../components/LoadingWrapper';


const useDsm = true;

const SelectDevice = ({
  account,
  accounts,
  devices,
  loading,
  services,
  returns,
  handleGetAccount,
  handleGetReturnableDevices,
  handleSelectDevices,
  history,
  selectedSerials,
  handleLoadReturns,
}) => {
  useEffect(() => {
    if (!account.requested) {
      handleGetAccount();
    }
    if (!devices.requested && useDsm) {
      handleGetReturnableDevices();
    }
    if (!returns.requested && useDsm) {
      handleLoadReturns();
    }
  }, [
    account,
    handleGetAccount,
    devices,
    handleGetReturnableDevices,
    returns,
    handleLoadReturns,
  ]);
  const submitDeviceSelection = useCallback(({ selectedDevices = [] }, { setFieldError }) => {
    // TODO: Figure out how to clear the form's errors
    // clearSubmitErrors();

    if (!selectedDevices.length) {
      window.scrollTo(0, 0);
      setFieldError('selectedDevices', 'Please select a device');
    } else {
      const s = selectedDevices.map(serialNumber => services.devices[serialNumber]);
      handleSelectDevices(s);
      history.push(RETURNS_SELECT_REASON);
    }
  }, [handleSelectDevices, history, services.devices]);

  if (returnsDisabled()) {
    return <Redirect to={RETURNS_DOWNTIME} />;
  }

  if (loading) {
    return <LoadingWrapper />;
  }

  if (flagEnabled('device-returns.disableOrders')) {
    return <RedirectToHelpAndSupport />;
  }

  const accountData = account && account.data;
  const accountNumber = accountData && accountData.accountNumber;
  const serviceAddress = accountData && accountData.serviceAddress;
  const hasLinkedAccounts = accounts && accounts.length > 1;

  return (
    <>
      <div className="returns-account-info">
        <AccountInfoPushdown
          accountNumber={accountNumber}
          hasLinkedAccounts={hasLinkedAccounts}
          serviceAddress={serviceAddress}
        />
      </div>
      <PageSection className="ui-grey">
        <h1 className="heading2">
          {'Select the devices you\'d like to return'}
        </h1>
        <Formik
          initialValues={{ selectedDevices: selectedSerials }}
          useValidation={false}
          onSubmit={submitDeviceSelection}
        >
          {({
            values: { selectedDevices },
            errors,
          } = {}) => (
            <>
              {errors.selectedDevices && <p className="form-control__error">{errors.selectedDevices}</p>}
              <Form className="form--has-fixed-action" noValidate>
                <Services services={services.services} />

                <div className="card card--default">
                  <div className="card__content">
                    <p>
                      Please note you can only return devices leased or rented from Xfinity.
                    </p>
                  </div>
                </div>
                <FixedActions selectedDevices={selectedDevices.length} />
              </Form>
            </>
          )}
        </Formik>
      </PageSection>
    </>
  );
};

const mapStateToProps = ({
  account,
  auth: { macaroon: { accounts = [] } = {} } = {},
  devices,
  order,
  returns,
}) => {
  const accountData = account?.data;
  return {
    account,
    accounts,
    devices,
    returns,
    loading: account.loading || devices.loading || returns.loading,
    services: transformServices({
      dsmDevices: devices.services,
      returns,
      accountData,
    }),
    selectedSerials: (order.selectedDevices || []).map(device => device.serialNumber),
  };
};

const mapDispatchToProps = {
  handleSelectDevices: selectDevices,
  handleGetAccount: getAccount,
  handleGetReturnableDevices: getReturnableDevices,
  handleLoadReturns: loadReturns,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectDevice);
